/* eslint-disable import/no-import-module-exports */
import Breadcrumb from '@Services/Breadcrumb';
import { databaseId as databaseIdSelector } from '@Selectors/StateParamsSelectors';
import { getAsync } from '@Containers/ResultsFilters/ResultsFiltersService';

import { keyifyParamsForFiltersRequest } from '../ListOfFiltersSelectors';

import { filtersFetchedType, updateGroupByIdType, updateFilterByIdType, addFilterGroupsByIdType } from '../ListOfFiltersConstants';

export function expandFiltersAccordingToBreadCrumb(filters, state) {
  const databaseId = databaseIdSelector(state);
  const { filters: filtersFromBreadCrumb } = Breadcrumb.getActiveBreadcrumbForDb(databaseId);

  if (!filtersFromBreadCrumb) {
    return filters;
  }

  return filters.map((item) => {
    const { id } = item;
    const filterFromBreadCrumb = filtersFromBreadCrumb.find((filter) => filter.property === id);
    if (filterFromBreadCrumb) {
      return {
        ...item,
        expanded: true,
      };
    }

    return item;
  });
}

export function disableCrossContextFiltersIfContextNotLoaded(filters, currentContext, relativeContextItems) {
  return filters.map((item) => {
    const { contextValue } = item;
    let disabled = false;
    if (contextValue && contextValue !== currentContext) {
      disabled = !relativeContextItems || !relativeContextItems.get(contextValue);
    }
    return {
      ...item,
      disabled,
    };
  });
}

export function fetchFilters(params, key, relativeContextItems) {
  return async (dispatch, getState) => {
    const state = getState();
    let filters = await getAsync(params);
    filters = expandFiltersAccordingToBreadCrumb(filters, state);
    filters = disableCrossContextFiltersIfContextNotLoaded(filters, params.context, relativeContextItems);

    dispatch({
      type: filtersFetchedType,
      payload: {
        key,
        data: filters,
      },
    });

    return filters;
  };
}

export function updateFilterById(key, filterId, data) {
  return {
    type: updateFilterByIdType,
    payload: {
      key,
      data,
      filterId,
    },
  };
}

export function toggleFilter(filter) {
  return (dispatch, getState) => {
    const state = getState();
    const id = filter.get('id');
    const expanded = filter.get('expanded');
    const key = keyifyParamsForFiltersRequest(state);
    const action = updateFilterById(key, id, {
      expanded: !expanded,
    });
    dispatch(action);
  };
}

export function updateGroupById(key, filterId, groupId, data) {
  return {
    type: updateGroupByIdType,
    payload: {
      key,
      data,
      groupId,
      filterId,
    },
  };
}

export function addFilterGroupsById(key, filterId, groups, groupCount, thesaurusGroups, hitCount, thesaurusRootId, index) {
  return {
    type: addFilterGroupsByIdType,
    payload: {
      key,
      groups,
      filterId,
      hitCount,
      groupCount,
      thesaurusGroups,
      thesaurusRootId,
      index,
    },
  };
}
